import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { ReceiveHistoryListing, ReceiveHistorySummary } from '~/models/modules/ReceiveHistorySummary';
import { PhysicalInventorySummary } from '~/models/modules/PhysicalInventorySummary';

@Injectable({ providedIn: 'root' })
export class CycleCountService extends ApiServiceBase {
 
  
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.assets);
    }




//#region locationsId
    GetStockPhysInvByDateAndLoc(locationsId : number[], model : any){
      let startdate = new Date(model.startDate)
      let data ={
        locationsId :locationsId,
        startEndDateRequest :  {
          startDate : new Date(model.startDate).toLocaleString(),
          endDate : new Date(model.endDate).toLocaleString()
        }
      }
      return this.http
      .post<PhysicalInventorySummary[]>(this._url(`/GetStockPhysInvByDateAndLoc`), data, {
        observe: 'response'})
      .pipe(map(augmentPaging));
    }
//#endregion

//#region  UpdateStockPhysInvList
UpdateStockPhysInvList(data: PhysicalInventorySummary[]){
  return this.http
      .post<PhysicalInventorySummary[]>(this._url(`/UpdateStockPhysInvList`), data, {
        observe: 'response'})
      .pipe(map(augmentPaging));
}

//#endregion

//#region  getPhysicalInventoryHistory
getPhysicalInventoryHistory(paramsObj?: any, model?: any){
  paramsObj = paramsObj || {};
  paramsObj.view = 'summary';
  let params = createHttpParams(paramsObj);

  return this.http
  .post<any[]>(this._url(`/grid-data`), model, {
      params,
      observe: 'response',
  })
  .pipe(map(augmentPaging));
}


//#endregion


//#region MostQtyChange
MostQtyChange(top: number = 10){
  return this.client.get(this._url(`/MostQtyChange/${top}`));
}

//#endregion


//#region NumberOfPhyInventorymentsInXMonths
NumberOfPhyInventorymentsInXMonths(top: number = 10){
  return this.client.get(this._url(`/NumberOfPhyInventorymentsInXMonths/${top}`));
}
//#endregion

//#region PhyInventoryTransactionPerUser
PhyInventoryTransactionPerUser(top: number = 10){
  return this.client.get(this._url(`/PhyInventoryTransactionPerUser/${top}`));
}

//#endregion

//#region Load Data Randomly
LoadDataRandomly(percentage:number, transactionId:number|null, countType:number){
  return this.client.get(this._url(`/data-randomly/${percentage}/${transactionId}/${countType}`));
}

//#endregion

LoadDraftedTransaction() {
    return this.client.get(this._url(`/drafted-transaction`));
  }

LoadOpenedTransaction() {
  return this.client.get(this._url(`/opened-transaction`));
}

 LoadCycleCountChuncks() {
    return this.client.get(this._url(`/chuncks`));
  }

  LoadCycleCountChunckVarianceDetails(chunckId:number) {
    return this.client.get(this._url(`/variance-details/${chunckId}`));
  }

UpdateDetails(model: any) {
        return this.client.put(this._url(``), model);
    }

Process(model:any){
return this.client.post(this._url(``),model);
}

AdjustProcess(model:any){
return this.client.post(this._url(`/adjust-process`),model);
}

// AdjustProcessAndClose(model:any){
// return this.client.post(this._url(`/adjust-process-close`),model);
// }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/AssetCycleCountTransaction${v}`);
    }
}
//

